/* eslint-disable */
import React, { useState, useCallback, useContext, createContext } from 'react';
import api from 'services';
import { toDate, dateNow } from 'utils/converters';
import { useRegColheitaManual } from 'hooks/providers/controles/registros/registroColheitaManual';
import { useRegColheitaPorPe } from 'hooks/providers/controles/registros/registroColheitaPorPe';
import { useRegColheitaMecanica } from 'hooks/providers/controles/registros/registroColheitaMecanica';
import { useRegMaquina } from 'hooks/providers/controles/registros/registroMaquinas';
import { useRegInsumo } from 'hooks/providers/controles/registros/registroInsumos';
import { useRegMdobra } from 'hooks/providers/controles/registros/registroMdobra';
import { useRegExtra } from 'hooks/providers/controles/registros/registroExtras';
import { useRegCalda } from 'hooks/providers/controles/registros/registroCaldas';
import { useRegColheitaSimplificada } from 'hooks/providers/controles/registros/registroColheitaSimplificada';
import { useNewToast } from 'hooks/newToast';
import { appWarnings } from 'utils/appWarnings';
import { useNotifications } from 'hooks/notifications';

const success = {
  type: 'success',
  autoClose: 3000,
};

const LIST = {
  content: [],
  pagination: undefined,
};

const getTalhaoRequestId = (talhao) => talhao?.id ?? talhao?.id_;

const RegAtividadeContext = createContext({});

export const RegistroAtividadeProvider = ({ children }) => {
  const { showToast } = useNewToast();

  const { insertRegColheitaManual } = useRegColheitaManual();
  const { insertRegColheitaPorPe } = useRegColheitaPorPe();
  const { insertRegColheitaMecanica } = useRegColheitaMecanica();
  const { insertRegExtra } = useRegExtra();
  const { insertRegInsumos } = useRegInsumo();
  const { insertRegCaldas } = useRegCalda();
  const { insertRegMaquina } = useRegMaquina();
  const { insertRegMaodeobra } = useRegMdobra();
  const { insertRegColheitaSimplificada } = useRegColheitaSimplificada();

  const { listLastFiveNotifications } = useNotifications();

  const [regAtividades, setRegAtividades] = useState(LIST);
  const [regAtividadesLoading, setRegAtividadesLoading] = useState(false);

  const [deleteLoading, setDeleteLoading] = useState(false);

  const [regAtividade, setRegAtividade] = useState({});
  const [regAtividadeLoading, setRegAtividadeLoading] = useState(false);

  const [regAtividadesPorTalhao, setRegAtividadesPorTalhao] = useState();
  const [regAtividadesPorTalhaoLoading, setRegAtividadesPorTalhaoLoading] =
    useState(false);
  const [insertAtividadeLoading, setInsertAtividadeLoading] = useState(false);
  const [insertDuplicateAtividadeLoading, setInsertDuplicateAtividadeLoading] =
    useState(false);

  const [regAtividadesFiltered, setRegAtividadesFiltered] = useState({
    content: [],
  });

  const [regAtividadesFilteredLoading, setRegAtividadesFilteredLoading] =
    useState(false);
  const [
    modifyRegAtividadesFilteredLoading,
    setModifyRegAtividadesFilteredLoading,
  ] = useState(false);

  const [regInsumosFiltered, setRegInsumosFiltered] = useState({
    content: [],
  });

  const [regInsumosFilteredLoading, setRegInsumosFilteredLoading] =
    useState(false);
  const [modifyRegInsumosFilteredLoading, setModifyRegInsumosFilteredLoading] =
    useState(false);

  const getRegAtividadeByTalhao = useCallback(async (filter) => {
    try {
      const filters = {
        ...filter,
        talhao: getTalhaoRequestId(filter?.talhao),
        fazenda: filter?.fazenda || filter?.fazenda?.id,
        atividade: filter?.atividade?.id,
      };

      setRegAtividadesPorTalhaoLoading(true);
      const response = await api
        .regAtividade()
        .getRegAtividadeByTalhao(filters);

      setRegAtividadesPorTalhao(response);
      setRegAtividadesPorTalhaoLoading(false);
    } catch (errors) {
      setRegAtividadesPorTalhaoLoading(false);
    }
  }, []);

  const getRegAtividades = useCallback(async (filter) => {
    try {
      const filters = {
        ...filter,
        talhao: getTalhaoRequestId(filter?.talhao),
        fazenda: filter?.fazenda || filter?.fazenda?.id,
        atividade: filter?.atividade?.id,
      };

      setRegAtividadesLoading(true);

      const response = await api.regAtividade().getRegAtividades(filters);

      setRegAtividades({
        content: response?.content || [],
        pagination: response?.pagination || undefined,
      });
    } finally {
      setRegAtividadesLoading(false);
    }
  }, []);

  const getRegAtividadesFiltered = useCallback(async (filter) => {
    try {
      const filters = {
        safra: filter?.safra,
        dateStart: filter?.dateStart,
        dateEnd: filter?.dateEnd,
        modo: filter?.modo?.id,
        talhao: getTalhaoRequestId(filter?.talhao),
      };

      setRegAtividadesFilteredLoading(true);
      const response = await api
        .regAtividade()
        .getRegAtividadesFiltered(filters);

      setRegAtividadesFiltered(response);
    } finally {
      setRegAtividadesFilteredLoading(false);
    }
  }, []);

  const modifyRegAtividadesFiltered = useCallback(
    async (data) => {
      try {
        const dataFormated = {
          safra: data?.safra,
          dateStart: data?.dateStart,
          dateEnd: data?.dateEnd,
          modo: data?.modo?.id,
          talhao: getTalhaoRequestId(data?.talhao),
          newValue: data?.newValue,
        };

        setModifyRegAtividadesFilteredLoading(true);
        await api.regAtividade().modifyRegAtividadesFiltered(dataFormated);

        showToast({
          ...success,
          message:
            'Alteração dos valores de registo de colheita feito com sucesso.',
        });
      } catch {
        showToast(
          appWarnings.Danger(
            'Ocorreu um erro ao tentar alterar os registros, tente novamente mais tarde!',
          ),
        );
      } finally {
        setModifyRegAtividadesFilteredLoading(false);
      }
    },
    [showToast],
  );

  const getRegInsumosFiltered = useCallback(async (filter) => {
    try {
      const filters = {
        safra: filter?.safra,
        dateStart: filter?.dateStart,
        dateEnd: filter?.dateEnd,
        talhao: getTalhaoRequestId(filter?.talhao),
        insumo: filter?.insumo?.id,
      };

      setRegInsumosFilteredLoading(true);
      const response = await api.regAtividade().getRegInsumosFiltered(filters);

      setRegInsumosFiltered(response);
    } finally {
      setRegInsumosFilteredLoading(false);
    }
  }, []);

  const modifyRegInsumosFiltered = useCallback(
    async (data) => {
      try {
        const dataFormated = {
          registroInsumoIds: data?.registroInsumoIds,
          newValue: data?.newValue,
        };

        setModifyRegInsumosFilteredLoading(true);
        await api.regAtividade().modifyRegInsumosFiltered(dataFormated);

        showToast({
          ...success,
          message:
            'Alteração dos valores de registro de insumos feito com sucesso.',
        });
      } catch {
        showToast(
          appWarnings.Danger(
            'Ocorreu um erro ao tentar alterar os registros, tente novamente mais tarde!',
          ),
        );
      } finally {
        setModifyRegInsumosFilteredLoading(false);
      }
    },
    [showToast],
  );

  const getRegAtividade = useCallback(async (id) => {
    try {
      if (!id) return false;
      setRegAtividadeLoading(true);
      const response = await api.regAtividade().getRegAtividade(id);
      setRegAtividade(response);
      setRegAtividadeLoading(false);
      return response;
    } catch (errors) {
      setRegAtividadeLoading(false);
      return false;
    }
  }, []);

  const insertAndUpdateRegAtividade = useCallback(
    async (id, data) => {
      try {
        setInsertAtividadeLoading(true);
        const {
          about,
          edit,
          extra,
          sprayMixture,
          inputs,
          mechanicalHarvesting,
          machine,
          labor,
          manualHarvest,
          colheitaPorPe,
          simplifiedHarvest,
        } = data;

        const isGastosGerais =
          Array.isArray(about?.talhao) &&
          about.talhao.length === 1 &&
          about.talhao[0]?.nome === 'GASTOS GERAIS';

        const blocosConsorcio = Array.isArray(about?.blocosConsorcio)
          ? about.blocosConsorcio
          : [];

        let talhoesPorSafra;

        if (blocosConsorcio.length > 0) {
          talhoesPorSafra = [];

          if (!isGastosGerais && about?.talhao?.length > 0 && about?.safra?.id) {
            talhoesPorSafra.push({
              safraId: about.safra.id,
              talhoesIds: about.talhao.map((item) => item.id),
            });
          }

          blocosConsorcio.forEach((bloco) => {
            if (bloco?.safra?.id && bloco?.talhoes?.length > 0) {
              talhoesPorSafra.push({
                safraId: bloco.safra.id,
                talhoesIds: bloco.talhoes.map((item) => item.id),
              });
            }
          });
        }

        const activityLogData = {
          id,
          safra: about?.safra?.id,
          talhao: 0,
          talhoesIds: isGastosGerais
            ? []
            : about?.talhao?.map((item) => item.id),
          ...(talhoesPorSafra?.length > 0 && { talhoesPorSafra }),
          fazenda: isGastosGerais
            ? about?.talhao?.[0]?.id
            : about?.talhao?.[0]?.gloFazendaId || 0,
          atividade: about?.atividade?.id,
          data: about?.data ? toDate(about?.data) : dateNow(),
          horaInicial: about?.horaInicial || null,
          horaFinal: about?.horaFinal || null,
          viagem: about?.viagem?.id ?? null,
          obs: about?.obs,
        };

        const response = await api
          .regAtividade()
          .insertRegAtividade(activityLogData);

        setRegAtividade(response);
        const registroId = response?.id;

        if (extra?.length > 0 && !edit?.extra) {
          await insertRegExtra(registroId, extra);
        }
        if (sprayMixture?.length > 0 && !edit?.sprayMixture) {
          await insertRegCaldas(registroId, sprayMixture);
        }
        if (inputs?.length > 0 && !edit?.inputs) {
          await insertRegInsumos(registroId, inputs);
          await listLastFiveNotifications();
        }
        if (mechanicalHarvesting?.length > 0 && !edit?.mechanicalHarvesting) {
          await insertRegColheitaMecanica(registroId, mechanicalHarvesting);
        }
        if (machine?.length > 0 && !edit?.machine) {
          await insertRegMaquina(registroId, machine);
        }
        if (labor?.length > 0) {
          const laborWithDate = labor.map((item) => ({
            ...item,
            data: about?.data ? toDate(about?.data) : dateNow(),
          }));
          await insertRegMaodeobra(registroId, laborWithDate);
        }
        if (manualHarvest?.length > 0 && !edit?.manualHarvest) {
          await insertRegColheitaManual(registroId, manualHarvest);
        }
        if (colheitaPorPe?.length > 0 && !edit?.colheitaPorPe) {
          await insertRegColheitaPorPe(registroId, colheitaPorPe);
        }
        if (simplifiedHarvest?.length > 0 && !edit?.simplifiedHarvest) {
          const salesTypeGlobal = data?.simplifiedHarvestSalesType || null;
          const harvestWithSalesType = simplifiedHarvest.map((item) => ({
            ...item,
            salesType:
              item?.salesType?.id != null ? item.salesType : salesTypeGlobal,
            salesTypeId:
              item?.salesType?.id ??
              item?.salesTypeId ??
              salesTypeGlobal?.id ??
              null,
          }));
          await insertRegColheitaSimplificada(
            registroId,
            harvestWithSalesType,
          );
        }

        showToast({
          ...success,
          message: id
            ? 'Registro de atividade editado com sucesso!'
            : 'Registro de atividade adicionado com sucesso!',
        });

        return response;
      } catch (err) {
        showToast(appWarnings.Danger(err));
        throw new Error(err);
      } finally {
        setInsertAtividadeLoading(false);
      }
    },
    [
      showToast,
      insertRegMaodeobra,
      insertRegColheitaManual,
      insertRegColheitaPorPe,
      insertRegColheitaMecanica,
      insertRegInsumos,
      insertRegCaldas,
      insertRegMaquina,
      insertRegExtra,
      insertRegColheitaSimplificada,
    ],
  );

  const removeRegistro = useCallback(
    async (registro, talhao) => {
      try {
        setDeleteLoading(true);
        await api.regAtividade().removeRegistro(registro);

        setRegAtividades((old) => ({
          ...old,
          content: old.content.filter((item) => item.id !== registro),
        }));

        setRegAtividadesPorTalhao((old) => {
          const existsTalhao = old && old.content && old.content[talhao];
          if (!existsTalhao) return old;
          return {
            ...old,
            content: {
              ...old.content,
              [talhao]: old.content[talhao]
                .map((item) => {
                  const atividade = item?.atividades.find(
                    (tempItem) => tempItem.id === registro,
                  );

                  if (
                    item.atividades &&
                    item.atividades.length > 0 &&
                    atividade
                  ) {
                    return {
                      ...item,
                      atividades: item.atividades.filter(
                        (ativ) => ativ.id !== registro,
                      ),
                    };
                  }

                  if (item.id === registro && item?.atividades.length > 0) {
                    return {
                      ...item,
                      ...item.atividades[0],
                      atividades: item.atividades.slice(
                        1,
                        item.atividades.length,
                      ),
                    };
                  }

                  if (item.id === registro) {
                    return {
                      id: null,
                    };
                  }

                  return item;
                })
                .filter((item) => item.id),
            },
          };
        });
        showToast({ ...success, message: 'Atividade removida com sucesso!' });

        setDeleteLoading(false);
      } catch (err) {
        setDeleteLoading(false);
        showToast(appWarnings.Danger(err));
        throw new Error();
      }
    },
    [showToast],
  );

  const insertDuplicateAtividade = useCallback(
    async (id, data) => {
      try {
        setInsertDuplicateAtividadeLoading(true);
        const dataDefault = {
          registro_id: id,
          safra: data.safra.id,
          talhao: getTalhaoRequestId(data?.talhao),
          fazenda: data?.talhao?.gloFazendaId,
          atividade: data.atividade.id,
          data: toDate(data.data),
        };

        const response = await api
          .regAtividade()
          .insertDuplicateAtividade(dataDefault);
        showToast({ ...success, message: 'Atividade duplicada com sucesso!' });
        return response;
      } catch (err) {
        showToast(appWarnings.Danger(err));
        throw new Error(err);
      } finally {
        setInsertDuplicateAtividadeLoading(false);
      }
    },
    [showToast],
  );

  return (
    <RegAtividadeContext.Provider
      value={{
        getRegAtividades,
        regAtividades,
        regAtividadesLoading,
        getRegAtividade,
        regAtividade,
        regAtividadeLoading,
        getRegAtividadeByTalhao,
        regAtividadesPorTalhao,
        regAtividadesPorTalhaoLoading,
        insertAndUpdateRegAtividade,
        setRegAtividade,
        removeRegistro,
        deleteLoading,
        insertAtividadeLoading,
        insertDuplicateAtividade,
        insertDuplicateAtividadeLoading,
        getRegAtividadesFiltered,
        regAtividadesFiltered,
        regAtividadesFilteredLoading,
        modifyRegAtividadesFiltered,
        modifyRegAtividadesFilteredLoading,
        getRegInsumosFiltered,
        regInsumosFiltered,
        regInsumosFilteredLoading,
        modifyRegInsumosFiltered,
        modifyRegInsumosFilteredLoading,
      }}
    >
      {children}
    </RegAtividadeContext.Provider>
  );
};

export function useRegAtividade() {
  const context = useContext(RegAtividadeContext);

  if (!context)
    throw new Error('useRegAtividade must be used within an RegAtividades');

  return context;
}
